/****************************************************
 * Module Name:  UploadTenderImagesModal.js
 * Project:      Pansuriya Impex Sales & Manufacturing
 * Owner:        info@pansuriyaimpex.com
 *
 * Copyright (c) Pansuriya Impex
 * All rights reserved.
 ****************************************************/
import React, { useState } from "react";
import Constants from "../../../utility/constants";
import { Box, Button, Typography } from "@mui/material";
import AssignmentTurnedInIcon from '@mui/icons-material/AssignmentTurnedIn';
import Modal from "react-bootstrap/Modal";
import logo from '../../../images/pansuriya.jpg'
import { LoadingButton } from "@mui/lab";
import { IoIosAddCircleOutline } from "react-icons/io";
import HighlightOffIcon from '@mui/icons-material/HighlightOff';

const UploadTenderImagesModal = ({
    show,
    loader,
    handleSave,
    handleClose,
    tenderstoneid,
}) => {
    const [selectedImages, setSelectedImages] = useState([]);
    const [selectedFiles, setSelectedFiles] = useState([]);

    const handleFileChange = (event) => {
        const files = event.target.files;
        if (files) {
            const imageArray = Array.from(files).map((file) => URL.createObjectURL(file));
            setSelectedImages((prevImages) => [...prevImages, ...imageArray]);
            setSelectedFiles((prevFiles) => [...prevFiles, ...files]);
        }
    };

    const handleRemoveImage = (index) => {
        setSelectedImages((prevImages) => prevImages.filter((_, i) => i !== index));
        setSelectedFiles((prevFiles) => prevFiles.filter((_, i) => i !== index));
    };

    const handleSubmit = () => {
        let data = new FormData();
        selectedFiles.forEach((file) => {
            data.append("files", file);
        });
        handleSave(data, tenderstoneid);
    };


    return (
        <div>
            <Modal
                show={show}
                onHide={handleClose}
                enforceFocus={false}
                backdrop="static"
                keyboard={true}
                size="lg"
            >
                <Modal.Header closeButton>
                    <Modal.Title>
                        <img
                            src={logo}
                            height="40pt"
                            width="40pt"
                            alt={Constants.COMPANY_SITE}
                        />
                        &nbsp;&nbsp;Upload Stone Images
                    </Modal.Title>
                </Modal.Header>

                <Modal.Body style={{ height: '400px', overflowY: 'auto', paddingBottom: '50px' }}>
                    <Box sx={{
                        paddingTop: "10px",
                        "& .MuiOutlinedInput-input": {
                            padding: "9px !important"
                        },
                        "& .MuiInputLabel-root": {
                            top: "-7px !important"
                        }
                    }}>
                        <div style={{ position: "relative", padding: "20px" }}>
                            <Button
                                style={{
                                    position: "absolute",
                                    top: "0px",
                                    right: "10px",
                                    padding: "10px",
                                    color: "white",
                                    border: "none",
                                    cursor: "pointer",
                                    zIndex: 1 // Ensure button is always on top
                                }}
                                component="label"
                                variant="contained"
                                size="small"
                                startIcon={<IoIosAddCircleOutline size={20} />}
                                onClick={() => document.getElementById("fileInput").click()}
                            >
                                ADD IMAGES
                            </Button>

                            <Box sx={{ display: "flex", width: "47%", alignItems: "center", marginLeft: "12px" }}>
                                <Box sx={{ display: "flex", alignItems: "center", width: "100%", paddingRight: "15px" }}>
                                    <Typography sx={{ width: "44%", fontWeight: 'bold' }}>Tender Stone Id :
                                    </Typography>
                                    <Typography sx={{ width: "60%", margin: 0, fontWeight: 'bold' }}>
                                        {tenderstoneid}
                                    </Typography>
                                </Box>
                            </Box>

                            <input
                                id="fileInput"
                                type="file"
                                multiple
                                accept="image/*"
                                style={{ display: "none" }}
                                onChange={handleFileChange}
                            />
                            <div
                                style={{
                                    marginTop: "25px",
                                    display: "flex",
                                    flexWrap: "wrap",
                                    gap: "10px",
                                    overflowY: "auto",
                                }}
                            >
                                {selectedImages.length === 0 ? (
                                    <div style={{ textAlign: "center", marginTop: "130px", color: "black", marginLeft: "240px" }}>
                                        <p>No images selected. Add images.</p>
                                    </div>
                                ) : (
                                    <div style={{ display: "flex", flexWrap: "wrap", marginTop: "25px" }}>
                                        {selectedImages.map((image, index) => (
                                            <div key={index} style={{ margin: "10px", position: "relative" }}>
                                                {/* Image Display */}
                                                <img
                                                    src={image}
                                                    alt={`selected-img-${index}`}
                                                    style={{
                                                        width: "100px",
                                                        height: "100px",
                                                        objectFit: "cover",
                                                        border: "2px solid #ddd",
                                                        borderRadius: "8px",
                                                        boxShadow: "0 4px 8px rgba(0, 0, 0, 0.2)",
                                                        transition: "transform 0.2s, box-shadow 0.2s",
                                                    }}
                                                />

                                                <HighlightOffIcon style={{
                                                    position: "absolute",
                                                    top: "-10px",
                                                    right: "-10px",
                                                    backgroundColor: "white",
                                                    borderRadius: "60%",
                                                    color: "black",
                                                    cursor: "pointer",
                                                    padding: "0px",
                                                    fontSize: "28px",
                                                    boxShadow: "0 2px 4px rgba(0, 0, 0, 0.1)",
                                                }} size={100}
                                                    onClick={() => handleRemoveImage(index)}
                                                />
                                            </div>
                                        ))}
                                    </div>
                                )}
                            </div>
                        </div>
                    </Box>
                </Modal.Body>

                <Modal.Footer>
                    <Box sx={{
                        "& .Mui-disabled": {
                            backgroundColor: "rgba(0, 0, 0, 0.12) !important",
                            color: "rgba(0, 0, 0, 0.26) !important"
                        }
                    }}>
                        <LoadingButton
                            sx={{ mr: 1 }}
                            variant="contained"
                            color="info"
                            onClick={handleSubmit}
                            loading={loader}
                            loadingPosition="start"
                            startIcon={<AssignmentTurnedInIcon />}
                            type="Submit"
                            disabled={selectedImages.length === 0}
                        >
                            Submit
                        </LoadingButton>
                    </Box>
                    <Button variant="contained" color="error" onClick={handleClose}>
                        Close
                    </Button>
                </Modal.Footer>
            </Modal>
        </div>
    );
};

export default UploadTenderImagesModal;